import { all, fork } from "redux-saga/effects";

import {
  preAddComments,
  preAddTimeTakeAway,
  preCreateOrder,
  preCreateOrderAndUser,
  preFetchOrderData,
  preFetchProductsCart,
  preSendTheOrder,
  watchAddComments,
  watchAddTimeTakeAway,
  watchCreateOrder,
  watchCreateOrderAndUser,
  watchFetchOrderData,
  watchFetchProductsCart,
  watchPlopToto,
  watchSendTheOrder,
} from "./order.saga";
import {
  preAddProduct,
  preDeleteProduct,
  preUpdateMenu,
  preUpdateProduct,
  watchAddProduct,
  watchDeleteMenu,
  watchDeleteProduct,
  watchUpdateMenu,
  watchUpdateProduct,
} from "./cart.saga";
import {
  preAddUserAddress,
  preGetUserData,
  preUpdateUserData,
  watchAddUserAddress,
  watchGetUserData,
  watchUpdateUserData,
} from "./user.saga";
import {
  preCheckServiceOpenRestaurant,
  preCreateTokenStripeRestaurant,
  watchCheckServiceOpenRestaurant,
  watchCreateTokenStripeRestaurant,
  watchUpdateFrozenSlots,
} from "./restaurant.saga";

export default function* IndexSaga() {
  yield all([
    //RESTAURANT
    watchUpdateFrozenSlots(),
    preCreateTokenStripeRestaurant(),
    watchCreateTokenStripeRestaurant(),
    preCheckServiceOpenRestaurant(),
    watchCheckServiceOpenRestaurant(),

    //CART
    watchUpdateProduct(),
    watchDeleteProduct(),
    watchDeleteMenu(),
    preUpdateProduct(),
    preDeleteProduct(),
    watchAddProduct(),
    watchUpdateMenu(),
    preUpdateMenu(),
    preAddProduct(),

    //ORDER
    watchCreateOrderAndUser(),
    preCreateOrderAndUser(),
    preFetchProductsCart(),
    watchFetchProductsCart(),
    preSendTheOrder(),
    watchSendTheOrder(),
    preCreateOrder(),
    watchCreateOrder(),
    preAddComments(),
    watchAddComments(),
    preFetchOrderData(),
    watchFetchOrderData(),
    preAddTimeTakeAway(),
    watchAddTimeTakeAway(),

    //USER
    watchAddUserAddress(),
    preAddUserAddress(),
    preGetUserData(),
    watchGetUserData(),
    preUpdateUserData(),
    watchUpdateUserData(),
  ]);
}

